import { defineWidget } from '../widget-types';
import type { BlockNode } from '../block-types';

const categoryGridDefaultBlocks: BlockNode[] = [
  {
    id: 'category-grid-heading',
    type: 'text',
    content: { type: 'text', value: 'Shop by Category', fontSize: 28, fontWeight: 700, textAlign: 'left' },
    layout: { order: 0, widthPct: 100 },
  },
  {
    id: 'category-grid-subheading',
    type: 'text',
    content: { type: 'text', value: 'Find what you\'re looking for', fontSize: 16, fontWeight: 400, textAlign: 'left' },
    layout: { order: 1, widthPct: 100 },
  },
];

export const categoryGridWidget = defineWidget({
  type: 'category-grid',
  schema: {
    label: 'Category Cards',
    description: 'Visual grid of product category cards with images',
    props: {
      showHeading: {
        type: 'boolean',
        label: 'Show Heading',
        default: true,
      },
      showSubheading: {
        type: 'boolean',
        label: 'Show Subheading',
        default: true,
      },
      categoryList: {
        type: 'collection-list',
        label: 'Collections',
        description: 'Select collections to display as cards',
        structural: true,
        default: '[]',
      },
      cardStyle: {
        type: 'enum',
        label: 'Card Style',
        options: ['overlay', 'compact'],
        default: 'overlay',
      },
      layout: {
        type: 'enum',
        label: 'Layout',
        options: ['slider', 'grid'],
        default: 'slider',
      },
      columns: {
        type: 'number',
        label: 'Columns',
        description: 'Number of columns (desktop)',
        min: 2,
        max: 12,
        default: 4,
      },
      tabletColumns: {
        type: 'number',
        label: 'Columns (Tablet)',
        description: 'Number of columns on tablet (≤1023px)',
        min: 1,
        max: 8,
        default: 3,
      },
      mobileColumns: {
        type: 'number',
        label: 'Columns (Mobile)',
        description: 'Number of columns on mobile (≤767px)',
        min: 1,
        max: 4,
        default: 2,
      },
      showHeaderLink: {
        type: 'boolean',
        label: 'Show Header Link',
        default: false,
      },
      headerLinkIcon: {
        type: 'icon',
        label: 'Header Link Icon',
        default: 'chevron-right',
      },
      headerLinkUrl: {
        type: 'link',
        label: 'Header Link URL',
      },
    },
    slots: {
      heading: { type: 'text', label: 'Section Heading' },
      subheading: { type: 'text', label: 'Section Subheading' },
      headerLinkText: { type: 'text', label: 'Header Link Text' },
    },
    dataDeps: ['categoryGrid'],
  },
  nameTh: 'การ์ดหมวดหมู่',
  descriptionTh: 'แสดงหมวดหมู่สินค้าในรูปแบบการ์ดพร้อมรูปภาพ',
  category: 'products',
  thumbnail: '/widget-thumbnails/category-grid.svg',
  defaults: {
    type: 'category-grid',
    props: {},
    slots: {
      heading: { value: 'Shop by Category' },
    },
  },
  defaultBlocks: categoryGridDefaultBlocks,
});
